const DEFAULT_AVAILABILITY_FILTER = 'filter.v.availability';
const DEFAULT_AVAILABILITY_VALUE = '1';

/**
 * @param {URL} url
 */
function isCollectionURL(url) {
  if (url.origin !== window.location.origin) return false;

  const pathParts = url.pathname.split('/').filter(Boolean);
  const collectionsIndex = pathParts.indexOf('collections');

  if (collectionsIndex === -1) return false;

  return pathParts.slice(collectionsIndex + 1).length === 1;
}

/**
 * @param {string} href
 */
function getAvailableCollectionURL(href) {
  const url = new URL(href, window.location.origin);

  if (!isCollectionURL(url) || url.searchParams.has(DEFAULT_AVAILABILITY_FILTER)) return;

  url.searchParams.set(DEFAULT_AVAILABILITY_FILTER, DEFAULT_AVAILABILITY_VALUE);

  return `${url.pathname}${url.search}${url.hash}`;
}

/**
 * @param {ParentNode} root
 */
function updateCollectionLinks(root = document) {
  root.querySelectorAll('a[href]').forEach((link) => {
    if (!(link instanceof HTMLAnchorElement)) return;

    const availableURL = getAvailableCollectionURL(link.href);
    if (availableURL) link.href = availableURL;
  });
}

updateCollectionLinks();

new MutationObserver((mutations) => {
  for (const mutation of mutations) {
    for (const node of mutation.addedNodes) {
      if (node instanceof Element) updateCollectionLinks(node);
    }
  }
}).observe(document.documentElement, { childList: true, subtree: true });
